// ===== FilterBar: estrutura de filtros unificada =====
// Desktop: layout idêntico ao anterior (.fb-rest usa display:contents).
// Mobile: mantém visíveis o controle principal, a busca e as ações;
// os filtros secundários entram num grupo recolhível ("Filtros").
import React from 'react';
import { Icon } from './icons.jsx';

function FilterBar({ children, className = "" }) {
  const [open, setOpen] = React.useState(false);
  const kids = React.Children.toArray(children).filter(Boolean);
  const isSearch = (k) => k?.props && typeof k.props.className === "string" && k.props.className.includes("fb-search");
  const isActions = (k) => (k?.props?.style && k.props.style.marginLeft === "auto")
    || (typeof k?.props?.className === "string" && k.props.className.includes("fb-right"));
  const primary = kids.slice(0, 1);
  const tail = kids.slice(1);
  const always = tail.filter(k => isSearch(k) || isActions(k));
  const rest = tail.filter(k => !isSearch(k) && !isActions(k));
  return (
    <div className={`filter-bar${open ? " fb-open" : ""}${className ? " " + className : ""}`}>
      {/* Região que rola: controle principal, busca e filtros secundários */}
      <div className="fb-scroll">
        {primary}
        {always.filter(isSearch)}
        {rest.length > 0 && (
          <button className={`fb-toggle${open ? " on" : ""}`} onClick={() => setOpen(o => !o)} aria-expanded={open}>
            <Icon name="filter" size={13} />
            <span>Filtros</span>
            <Icon name={open ? "chevron-up" : "chevron-down"} size={12} />
          </button>
        )}
        <div className="fb-rest">{rest}</div>
      </div>
      {/* Região fixa: contadores e ação primária nunca saem da tela */}
      <div className="fb-actions">{always.filter(k => !isSearch(k))}</div>
    </div>
  );
}
export { FilterBar };
